import React, { useState } from 'react';
import { Menu, Icon, Accordion } from 'semantic-ui-react';
import { NavLink} from "react-router-dom";
import './CmsMenu.scss'
import { useAppSelector } from "../../hooks/hooks";
import * as R from '../../common/routes';

interface CmsMenuProps {
    collapsed: boolean;
}

const CmsMenu: React.FC<CmsMenuProps> = ({collapsed}) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const cms = useAppSelector(state => state.Auth.cms);

    const handleAccordionClick = (index: any) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div id="mainMenu">
            <Accordion as={Menu} vertical inverted>
                <Accordion.Title active={activeIndex === 0} index={0} onClick={() => handleAccordionClick(0)} as={Menu.Item}>
                    <Icon name="bullseye" size='large' />
                    {!collapsed &&
                        <span style={{ marginLeft: '8px' }}>DARTS</span>
                    }
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                    <Menu.Menu>
                        {cms['darts.games'] &&
                            <Menu.Item as={NavLink} to={R.CMS_DARTS_GAMES}>
                                <Icon name="game" size='large' />
                                {!collapsed &&
                                    <span style={{ marginLeft: '8px' }}>games</span>
                                }
                            </Menu.Item>
                        }
                        <Menu.Item as={NavLink} to={R.CMS_DARTS_PLAYERS}>
                            <Icon name="users" size='large' />
                            {!collapsed &&
                                <span style={{ marginLeft: '8px' }}>players</span>
                            }
                        </Menu.Item>
                        <Menu.Item as={NavLink} to={R.CMS_DARTS_TOURNAMENT}>
                            <Icon name="trophy" size='large' />
                            {!collapsed &&
                                <span style={{ marginLeft: '8px' }}>tournaments</span>
                            }
                        </Menu.Item>
                        {cms['darts.competitions'] &&
                            <Menu.Item as={NavLink} to={R.CMS_DARTS_COMPETITION}>
                                <Icon name="university" size='large' />
                                {!collapsed &&
                                    <span style={{ marginLeft: '8px' }}>competitions</span>
                                }
                            </Menu.Item>
                        }
                    </Menu.Menu>
                </Accordion.Content>
            </Accordion>
            <Menu.Item>
                <Icon name="table tennis" size='large' />
                {!collapsed &&
                    <span style={{ marginLeft: '8px' }}>Table-Tennis</span>
                }
            </Menu.Item>
            <Menu.Item>
                <Icon name="chart bar" size='large' />
                {!collapsed &&
                    <span style={{ marginLeft: '8px' }}>Snooker</span>
                }
            </Menu.Item>
            {cms["management"] &&
                <Accordion as={Menu} vertical inverted>
                    <Accordion.Title active={activeIndex === 1} index={1} onClick={() => handleAccordionClick(1)} as={Menu.Item}>
                        <Icon name="shield" size='large' />
                        {!collapsed &&
                            <span style={{ marginLeft: '8px' }}>ACCESS MANAGEMENT</span>
                        }
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === 1}>
                        <Menu.Menu>
                            {cms['management.users'] &&
                                <Menu.Item as={NavLink} to={R.CMS_ACCESS_USERS}>
                                    <Icon name="street view" size='large' />
                                    {!collapsed &&
                                        <span style={{ marginLeft: '8px' }}>users</span>
                                    }
                                </Menu.Item>
                            }
                            {cms['management.clients'] &&
                                <Menu.Item as={NavLink} to={R.CMS_ACCESS_CLIENTS}>
                                    <Icon name="users" size='large' />
                                    {!collapsed &&
                                        <span style={{ marginLeft: '8px' }}>clients</span>
                                    }
                                </Menu.Item>
                            }
                            {cms['management.listeners'] &&
                                <Menu.Item as={NavLink} to={R.CMS_ACCESS_LISTENERS}>
                                    <Icon name="search" size='large' />
                                    {!collapsed &&
                                        <span style={{ marginLeft: '8px' }}>listeners</span>
                                    }
                                </Menu.Item>
                            }
                            {cms['management.roles'] &&
                                <Menu.Item as={NavLink} to={R.CMS_ACCESS_ROLES}>
                                    <Icon name="list ul" size='large' />
                                    {!collapsed &&
                                        <span style={{ marginLeft: '8px' }}>roles</span>
                                    }
                                </Menu.Item>
                            }
                        </Menu.Menu>
                    </Accordion.Content>
                </Accordion>
            }
            <Menu.Item as={NavLink} to={R.MAIN}>
                <Icon name="sign out alternate" size='large' />
                {!collapsed &&
                    <span style={{ marginLeft: '8px' }}>SCHEDULE</span>
                }
            </Menu.Item>
        </div>
    );
}

export default CmsMenu;